import React from 'react';
import ClaimLanding from './landing';
import ClaimLink from './link';
import ClaimExpired from './expired';
import Page from '../../components/page';
import MobileOnly from '../../components/mobile-only';

const pages = {
  landing: 0,
  link: 1,
  expired: 2,
};
export default function Claim(props) {
  const {
    index,
    config,
    presenter,
    notificationType,
    showMobileOnly,
    initialToken,
    language,
    languagePolicies,
  } = props;
  return (
    <>
      {showMobileOnly && (
        <MobileOnly
          onContinue={
            config.view_mode === 'mobile-first'
              ? () => {
                  presenter.onContinueClick();
                }
              : null
          }
        />
      )}
      {!showMobileOnly && (
        <>
          <Page key="claim-expired" number={pages.expired} current={index}>
            <ClaimExpired config={config} />
          </Page>
          <Page key="claim-link" number={pages.link} current={index}>
            <ClaimLink config={config} notificationType={notificationType} />
          </Page>
          <Page key="claim-landing" number={pages.landing} current={index}>
            <ClaimLanding
              config={config}
              onRegister={(type) => {
                presenter.onRegister(type);
              }}
              initialToken={initialToken}
              language={language}
              languagePolicies={languagePolicies}
            />
          </Page>
        </>
      )}
    </>
  );
}
Claim.Page = pages;
